import React from 'react'
import styled from 'styled-components'

import maanrakennus from '../images/maaurakointi.jpg'
import maatalous from '../images/maatalous.png'
import auraus from '../images/auraus.jpg'

import Navigation from '../components/Navigation/Navigation'
import Hero from '../components/Hero/Hero'
import Footer from '../components/Footer/Footer'
import Section from '../components/Section/Section'
import Contact from '../components/Contact/Contact'
import colors from '../colors'


const Page = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background: transparent;
`

const Row = styled.div`
    display: flex;
    align-items: stretch;
    flex-direction: row;

    @media only screen and (max-width: 768px) {
        flex-direction: column;

        &.invert{
            flex-direction: column-reverse;
        }
      }
`


const Divider = styled.div`
    display: flex;
    height: 3px;
    width: 100%;
    background-color: ${colors.orange};
`

const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 50px;
    color: ${colors.darkgrey};
    text-align:center;
    align-items: center;

    ul {
        list-style: none;
        padding: 0px;
    }

    h2{
        font-family: 'Yanone Kaffeesatz', sans-serif;
        font-size: 42px;
    }
`

const LandingPage = () => {
    return (
        <Page>
            <Navigation />
            <Hero />

            <Divider />
            <Section style={{backgroundColor: colors.darkgrey}} >
                <ContentArea style={{ color: colors.lightgrey }}>
                    <p style={{padding: '0px 50px'}}>
                    Ryklin Oy on Lietolainen perheyritys, joka aloitti toimintansa vuonna 1989 toiminimimuotoisena ja muuttui osakeyhtiöksi vuonna 2012. 
                    Palveluihimme kuuluu teiden ja pihojen kunnossapito, maanrakennus sekä maatalousurakointi. 
                    Toimimme laaja-alaisesti Varsinais-Suomen alueella. Palvelemme pitkällä kokemuksella niin yksityisiä kotitalouksia, yritysasiakkaita kuin taloyhtiöitäkin. 
                    Monipuolisen kalustomme ansiosta kykenemme tarttumaan erilaisiin urakoihin.
                    Lue lisää palveluistamme ja ota meihin yhteyttä, niin teemme tarjouksen.
                    </p>
                </ContentArea>
            </Section>

             {/* Pihojenkunnossapito */}
            <Divider />
            <Row style={{ backgroundColor: '#bfbdc1' }}>
                <Section  background={auraus} />
                <Section id="kunnossapito" direction="column" align="left">
                    <ContentArea style={{ color: colors.darkgrey }}>
                        <h2>Teiden ja pihojen kunnossapito</h2>
                        <p>
                        Tarjoamme laaja-alaista pihojen ja teiden kunnossapitoa ympäri vuoden. 
                        Talvisin kunnossapidon tarkoitus on varmistaa pihojen ja teiden turvallisuus ja 
                        kesäisin palvelumme varmistavat ympäristön siisteyden ja viihtyvyyden. 
                        Palvelemme joustavasti ja nopeasti silloinkin, kun Suomen sääolosuhteet yllättävät.
                           <br/> <br/> 
                           <b>Talvikunnossapito:</b>
                            <ul>
                            <li>- Lumen auraus</li>
                            <li>- Teiden ja pihojen hiekoitus</li>
                            <li>- Teiden ja katujen suolaus</li>
                            <li>- Polanteen poisto</li>
                            <li>- Lumensiirrot</li>
                            </ul>

                            <b>Kesäkunnossapito:</b>
                            <ul>
                                <li>- Pihojen ja teiden harjaus ja pesu</li>
                                <li>- Lanaukset ja suolaukset</li>
                                <li>- Tienpientareiden leikkuut</li>
                                <li>- Ruohonleikkuu</li>
                            </ul>
                        </p>
                    </ContentArea>
                </Section>
            </Row>

            {/* Maanrakennus */}
            <Divider />
            <Row className={'invert'} style={{ backgroundColor: colors.darkgrey }}>
                <Section id="maanrakennus" direction="column" align="left">
                    <ContentArea style={{ color: colors.lightgrey }}>
                        <h2>Maanrakennus</h2>
                        <p>
                        Toteutamme monipuolisesti erilaisia maanrakennustöitä erilaisiin kohteisiin Varsinais-Suomen alueella. 
                        Maanrakennuskalustomme soveltuu erinomaisesti niin pieniin kuin suuriinkin maanrakennuskohteisiin.
                        Alla esimerkkejä maanrakennuspalveluistamme.

                            <ul>
                                <li>- Talojen pohjatyöt</li>
                                <li>- Rakennusten salaojitukset ja sadevesijärjestelmät</li>
                                <li>- Maansiirrot ja maa-ainesten vaihdot</li>
                                <li>- Pihojen muotoilut</li>
                                <li>- Ojien kaivuu</li>
                                <li>- Tonttipuiden kaadot ja raivaukset</li>
                            </ul>
                    </p>
                    </ContentArea>
                </Section>
                <Section height={'500px'}  background={maanrakennus} />
            </Row>

             {/* Maataloudenkoneurakointi */}
            <Divider />
            <Row style={{ backgroundColor: colors.lightgrey }}>
                <Section height={'500px'} background={maatalous} />
                <Section id="maataloudenurakointi" direction="column" align="left">
                    <ContentArea style={{ color: colors.darkgrey }}>
                        <h2>Maatalousurakointi</h2>
                        <p>
                        Tarjoamme monipuolisia maatalousurakoinnin palveluita sekä maatalousyrittäjille että 
                        yksityisille asiakkaille Varsinais-Suomen alueella. 
                        Kauttamme voit tilata muun muassa seuraavia palveluita:

                        <ul>
                            <li>- Maanmuokkaustyöt: kyntö, kultivointi, lautasmuokkaus tai äestys</li>
                            <li>- Kylvöt: Väderstad rapid</li>
                            <li>- Puinti</li>
                            <li>- Kasvinsuojeluruiskutukset</li>
                            <li>- Viljojen kuivaus</li>
                        </ul>
                    </p>
                    </ContentArea>
                </Section>
            </Row>

            {/* Yhteydenotot ja yhteystiedot */}
            <Divider />
            <Contact />

            {/* Kalustolle kokonaan oma sivu */}

            {/* Referenssit */}

            {/* Lisää puuttuvat fonttimääritykset */}
            <Footer />
        </Page>
    )
}

export default LandingPage